import PropTypes from 'prop-types';
import React from 'react';
import {useTrackFont} from '../../../containers/DataContainer/siteSettings/withTrackFont';
import {withoutSize} from '../../../services/env/siteSettings/fonts/fonts';
import {LinkButton} from '../../ui/LinkButton/LinkButton';
import {SVGIcon} from '../../ui/SVGIcon/SVGIcon';
import {EXTERNAL_LINK_MUSIC_PLATFORMS} from '../ExternalLinks.constants';
import styles from './ExternalLink.scss';
import {SvgComponent} from '../../../reactDomTypes';

interface Props {
  serviceName: string;
  url: string;
  service: string;
  children: React.ReactNode;
  actionType: string;
  logoSVG: SvgComponent;
  logoAccName?: string;
  onActionButtonClick: (params: {buttonName: string; musicPlatform: string}) => void;
}

export const ExternalLink: React.FC<Props> = ({
  serviceName,
  service,
  url,
  logoSVG,
  logoAccName,
  actionType,
  onActionButtonClick,
  children,
}) => {
  const trackFont = useTrackFont();
  const externalLinkStyle = withoutSize(trackFont);
  const handleActionButtonClick = () => {
    onActionButtonClick({
      buttonName: actionType.toLowerCase(),
      musicPlatform: EXTERNAL_LINK_MUSIC_PLATFORMS[service],
    });
  };

  return (
    <div className={styles.externalLink} style={externalLinkStyle} data-hook="external-link">
      <a
        className={styles.infoContainer}
        href={url}
        target="_blank"
        onClick={handleActionButtonClick}
        data-hook="serviceLink"
        rel="noreferrer"
      >
        <SVGIcon Svg={logoSVG} className={styles.serviceLogo} accName={logoAccName} />
        <div className={styles.serviceName} data-hook="service-name">
          {serviceName}
        </div>
      </a>
      <LinkButton className={styles.serviceActionButton} href={url} target="_blank" onClick={handleActionButtonClick}>
        {children}
      </LinkButton>
    </div>
  );
};

ExternalLink.propTypes = {
  serviceName: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  service: PropTypes.string.isRequired,
  children: PropTypes.node,
  actionType: PropTypes.string.isRequired,
  logoSVG: PropTypes.any.isRequired,
  logoAccName: PropTypes.string,
  onActionButtonClick: PropTypes.func.isRequired,
};
